import { Component } from '@angular/core';
import { DataService } from '../../services/data.service';

@Component({
	selector: 'nm-header',
	templateUrl: './header.html',
	styleUrls: ['./header.css']
})
export class NmHeader {
	public username: string;

	public constructor(
		private data: DataService
	) {
		let profile = this.data.user.whoami();
		this.username = profile.name;
	}

	public logout() {
		this.data.user.logout();
	}
}


// WEBPACK FOOTER //
// ./src/widgets/header/header.ts